import Nullstack from 'nullstack';
export default function IconUserSearch({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-user-search",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h1"
  }), "   ", Nullstack.element("circle", {
    cx: "16.5",
    cy: "17.5",
    r: "2.5"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 19.5l2.5 2.5"
  }), " ");
}